"use strict";
/**
 * 该文件用来定义合约quote支持的币种
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FUTURES_QUOTE_MAP = void 0;
exports.FUTURES_QUOTE_MAP = ["USDT", "BTC", "ETH", "SOL"];
